module.exports = __webpack_public_path__ + "media/images/new/roadpass-inline-logo@2x-f6dd1584705dd8dc207c0d864f67ef02.png";